import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

// Define expected data structure for this node
interface FilterNodeData {
  label?: string;
  filterCount?: number; // Example: show how many filters are configured
}

const FilterNode: React.FC<NodeProps<FilterNodeData>> = ({ data }) => {
  const label = data?.label || 'Filters';
  const count = data?.filterCount ?? 0;

  return (
    <div className="playbook-node filter-node" style={{ width: 180 }}>
      <Handle type="target" position={Position.Left} id="input" style={{ background: '#555' }} />
      <div className="playbook-node-header" style={{ justifyContent: 'center' }}>
        <strong>{label}</strong>
      </div>
      <div style={{ padding: '5px 0', fontSize: '0.9em', color: '#555', textAlign: 'center' }}>
        ({count} configured)
      </div>
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#555' }} />
    </div>
  );
};

export default FilterNode;
